export default (Vue, options) => {
  const env = {
    mapbox: {
      accessToken: process.env.MAPBOX_ACCESS_TOKEN,
      mapStyle: process.env.MAPBOX_MAP_STYLE,
    },
  };
  Vue.prototype.$env = env;
};
